import React from "react";
import PageHeader from "../PageHeader"; // Import the component
import ContactUsSection from "../ContactUs"; // Your existing About Section
import heroBackImage from "../images/hero/hero.webp"; // Import the background image you want

const ContactPage = () => {
  
  // 1. Define the breadcrumb path
  const breadcrumbLinks = [
    { label: "الرئيسية", path: "/" },
    { label: "تواصل معنا", path: "/contact" } // The last one is the active page
  ];

  return (
    <>
      {/* 2. Use the Component */}
      <PageHeader 
        title="تواصل معنا" 
        bgImage={heroBackImage} 
        breadcrumbs={breadcrumbLinks} 
      />

      {/* The rest of your page content */}
      <ContactUsSection />
    </>
  );
};

export default ContactPage;